import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Kpimaster } from '../models/commission/kpimaster.model';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { ExcelHeadersModel } from '../models/excelheaders/excelheaders.model';

@Injectable({
    providedIn: 'root'
})
export class ExcelHeadersService {

    private host = environment.apiUrl + "excelheaders";
    public loggedinUser: string = '';
    opts = [];

    constructor(private http: HttpClient, private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        if (this.loggedinUser == "" || this.loggedinUser == null) {
            this.loggedinUser = "NA"
        } else {
            this.loggedinUser = this.authGaurdService.loginUser();
        }
    }

    public getKPIExcelHeaders(): Observable<ExcelHeadersModel[]> {
        return this.http.get<ExcelHeadersModel[]>(`${this.host}/getkpiexcelheaders`);
    }

    public getReportTypes(): Observable<ExcelHeadersModel[]> {
        return this.http.get<ExcelHeadersModel[]>(`${this.host}/getreporttypes`);
      }

      public fetchHeaders(id: number): Observable<ExcelHeadersModel[]> {
        return this.http.get<ExcelHeadersModel[]>(`${this.host}/getheaders/` + id);
      }
    
      public fetchButtons(id: number): Observable<ExcelHeadersModel[]> {
        return this.http.get<ExcelHeadersModel[]>(`${this.host}/getbuttons/` + id);
      }
    
      public updateHeaders(headersEditModels: ExcelHeadersModel[]): Observable<ExcelHeadersModel[]> {
        return this.http.post<ExcelHeadersModel[]>(`${this.host}/updateheaders`, headersEditModels);
      }
    
      public updateButtons(buttonsEditModels: ExcelHeadersModel[]): Observable<ExcelHeadersModel[]> {
        return this.http.post<ExcelHeadersModel[]>(`${this.host}/updatebuttons`, buttonsEditModels);
      }

    public getJsonsList(salesChannels: string, commPlanId: number) {
        let url = this.host + '/getjsonslist/' + salesChannels + "/" + commPlanId;
        return this.http.get<ExcelHeadersModel[]>(url)
          .pipe(
            map((data: ExcelHeadersModel[]) => {
              return data;
    
            }), catchError(error => {
              this.logger.info(' error ==> ', error);
              return throwError('Something went wrong!');
            })
          )
      }

      uploadJSON(file: File, gridName: string, sql: string, pageName: string, orderBy: number,  kpiId: number, report_type: string, description: string,commPlanId : number): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
    
        var kpiIdStr: string;
        var field_valueStr: string;
        var commPlanIdStr: string;
    
       console.log(kpiId);
       console.log(commPlanId);
    
        if (!kpiId) {
          kpiIdStr = "0";
        }else{
          kpiIdStr = kpiId.toString();
        }
    
        if (!commPlanId) {
          commPlanIdStr = "0";
        }else{
          commPlanIdStr = commPlanId.toString();
        }
    
        console.log(kpiIdStr);
       
        if (!report_type) {
          field_valueStr = "NA";
        }else{
          field_valueStr = report_type;
        }
    
        //formData.append('file', file);
        formData.append('pageName', pageName);
        formData.append('description', description);
        formData.append('gridName', gridName);
        formData.append('orderBy', orderBy.toString());
        formData.append('sql', sql);
        formData.append('kpiId', kpiIdStr);
        formData.append('comm_plan_id', commPlanIdStr);
        formData.append('report_type', field_valueStr);
        formData.append('current_user', this.loggedinUser);
    
        const req = new HttpRequest('POST', `${this.host}/uploadjsons`, formData, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }
    
      updateJSON(file: File, gridName: string, sql: string, pageName: string, orderBy: number, commPlanId: number, salesChannel: string, kpiId: number, id: number): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
        console.log("file === " + file);
    
        var copid: string;
        var kid: string;
        if (commPlanId == null) {
          copid = "0";
        } else {
          copid = commPlanId.toString();
        }
    
        if (kpiId == null) {
          kid = "0";
        } else {
          kid = kpiId.toString();
        }
    
        formData.append('file', file);
        formData.append('gridName', gridName);
        formData.append('sql', sql);
        formData.append('pageName', pageName);
        formData.append('orderBy', orderBy.toString());
        formData.append('commPlanId', copid);
        formData.append('kpiId', kid);
        formData.append('salesChannel', salesChannel);
        formData.append('id', id.toString());
        formData.append('current_user', this.loggedinUser);
    
        const req = new HttpRequest('PUT', `${this.host}/updatejsons`, formData, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }

      updateJSONWithoutFile(gridName: string, sql: string, pageName: string, orderBy: number, commPlanId: any, salesChannel: string, kpiId: any, id: number): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
    
        var copid: string;
        var kid: string;
        if (commPlanId == null) {
          copid = "0";
        } else {
          copid = commPlanId.toString();
        }
    
        if (kpiId == null) {
          kid = "0";
        } else {
          kid = kpiId.toString();
        }
    
        formData.append('gridName', gridName);
        formData.append('sql', sql);
        formData.append('pageName', pageName);
        formData.append('orderBy', orderBy.toString());
        formData.append('commPlanId', copid);
        formData.append('kpiId', kid);
        formData.append('salesChannel', salesChannel);
        formData.append('id', id.toString());
        formData.append('current_user', this.loggedinUser);
    
        const req = new HttpRequest('PUT', `${this.host}/updatejsonswithoutfile`, formData, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }
    
      cloneData(sc: string, commId: number, commPlanId: number, salesChannel: string): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();
    
        var copid: string;
        if (commPlanId == null) {
          copid = "0";
        } else {
          copid = commPlanId.toString();
        }
    
        console.log("commId === " + commId);
        console.log("sc === " + sc);
    
        console.log("commPlanId === " + copid);
        console.log("salesChannel === " + salesChannel);
    
        formData.append('commId', commId.toString());
        formData.append('sc', sc);
    
        formData.append('commPlanId', copid);
        formData.append('salesChannel', salesChannel);
        formData.append('current_user', this.loggedinUser);
    
        const req = new HttpRequest('POST', `${this.host}/clonedata`, formData, {
          reportProgress: true,
          responseType: 'json'
        });
        return this.http.request(req);
      }
    
}
